export enum BannerLocationEnum {
  Sitewide = 'Sitewide',
  WorkCenter = 'Work Center',
  Application = 'Application'
}
